import { useCallback } from 'react'

import { FixedBanner, TextLink } from '@circlefin/components'
import { useMoney } from '@circlefin/hooks'
import { useModal } from '@circlefin/modal-router'
import { routes } from '@services/sections/modal'
import useTranslation from 'next-translate/useTranslation'

import type { IncompleteChainedTransfer } from '@shared/graphql'

export interface ResumeTransferBannerSingleProps {
  /**
   * Transfer.
   */
  transfer?: IncompleteChainedTransfer
}

export const ResumeTransferBannerSingle: React.FC<
  ResumeTransferBannerSingleProps
> = ({ transfer }) => {
  const { t } = useTranslation('ace')
  const { router } = useModal()
  const { money } = useMoney()

  const resumeSingleTransfer = useCallback(
    (id: string) => () => {
      router.push({
        pathname: routes.blockchain.aceSendOnchain.send,
        query: {
          id,
        },
      })
    },
    [router],
  )

  if (!transfer) {
    return null
  }

  return (
    <FixedBanner status="warning">
      <FixedBanner.Title>
        {t('resumeTransferBanner.singleTransfer.title')}
      </FixedBanner.Title>

      <FixedBanner.Description>
        {t('resumeTransferBanner.singleTransfer.description', {
          amount: money({
            number: transfer.amount.amount,
            variant: transfer.amount.currency,
            options: {
              symbol: true,
              signDisplay: false,
            },
          }),
        })}

        <TextLink
          onClick={resumeSingleTransfer(transfer.id)}
          size="sm"
          variant="primary"
        >
          {t('resumeTransferBanner.singleTransfer.cta')}
        </TextLink>
      </FixedBanner.Description>
    </FixedBanner>
  )
}
